import React, { useState, useRef, useEffect, useContext } from "react";
import "../assets/css/--component-cart.css";
import "../assets/css/--component-checkout.css";
import item from "../assets/images/burgerImg.png";
import { cartCheckout, deleteCart, getProductCart, updateCart } from "../helper/backend-methods";
import { use } from "react";
import { useNavigate } from "react-router-dom";
import AppLoader from "./AppLoader";
import { useCart } from "../context/cartProvider";
import { GlobalContext } from "../context";
import Carousel from "react-multi-carousel";
import menu from "../assets/images/mains-logo.png";
import { Modal, ModalBody } from "reactstrap";
import { addCart } from "../helper/backend-methods";
import { customToast } from "./customToast";
import ProductCustomizationModal from "./ProductCustomizationModal";

function CartDrawer({ cartItemCount, isUpdateCart }) {
  const { updateCartCount, cartDrawer, updateCartDrawer } = useContext(GlobalContext);
  const { isCartOpen, closeCart } = useCart();
  const [cartItems, setCartItems] = useState({
    CartItems: [],
  });
  const [swiperInitialized, setSwiperInitialized] = useState(false);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [tax, setTax] = useState("0.00");
  const [grandTotal, setGrandTotal] = useState("0.00");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [viewAddons, setViewAddons] = useState(false);


  const computeRelatedProductsFromCart = (cartItemsList) => {
    if (!cartItemsList || !Array.isArray(cartItemsList)) return [];
    let _related = [];
    cartItemsList.forEach((i) => {
      if (i.RelatedProductDTOs != null) {
        _related = _related.concat(i.RelatedProductDTOs);
      }
    });
    return _related.filter(
      (product, index, self) => index === self.findIndex((p) => p.Id === product.Id)
    );
  };

  /* Quantity */

  const calculateIndividualQuantity = (id) => {
    let quantity = 0;
    cartItems.CartItems.filter((i) => i.Id === id).map((i) => (quantity = i.Product.Quantity));
    return quantity;
  };

  const adjustQty = async (id, Increment) => {
    cartItems.CartItems.filter((i) => i.Id === id).map((i) => (i.Product.Quantity += Increment ? 1 : -1));
    if (calculateIndividualQuantity(id) == 0) {
      cartItems.CartItems = cartItems.CartItems.filter((i) => i.Id !== id);
      cartItems.SubTotal = cartItems.CartItems.reduce((sum, item) => sum + item.Product._Price * item.Product.Quantity, 0).toFixed(2);
      setCartItems({ ...cartItems });
      await removeCartItem(id);
      return;
    }
    cartItems.CartItems = cartItems.CartItems.map((i) => {
      if (i.Id === id) {
        i.Product.Total = i.Product._Price * i.Product.Quantity;
      }
      return i;
    });
    updateCartItem(id, Increment);
  };

  const calculateSubTotal = () => {
    const subtotalNum = Number(cartItems.SubTotal);
    if (isNaN(subtotalNum) || subtotalNum === null || subtotalNum === undefined) {
      return "0.00";
    }
    return subtotalNum.toFixed(2);
  };

  /* Total */
  const subtotal = calculateSubTotal();
  const getCartItems = () => {
    setLoading(true);
    getProductCart()
      .then(({ data }) => {
        if (data.Status) {
          let _relatedProducts = [];
          data.Data.CartItems = data.Data.CartItems.map((i) => {
            i.Product._Price = i.Product.Total / i.Product.Quantity;
            if (i.RelatedProductDTOs != null) {
              _relatedProducts = _relatedProducts.concat(i.RelatedProductDTOs);

              _relatedProducts = _relatedProducts.filter(
                (product, index, self) =>
                  index === self.findIndex(p => p.Id === product.Id)
              );
            }
            return i;
          });
          setCartItems(data.Data);
          setRelatedProducts(_relatedProducts);
          calculatedTotal(data.Data);
        } else if (data.StatusCode === 1019 || data.StatusCode === 1020 || data.StatusCode == 1018) {
          // Session expired, cart is empty or user not authenticated
          setCartItems({ CartItems: [] });
          if (data.Data == null) {
            calculatedTotal({});
          }
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setCartItems({ CartItems: [] });
      });
  };

  const updateCartItem = (id, qty) => {
    updateCart({
      CartItemId: id,
      Increment: qty,
    })
      .then(({ data }) => {
        if (data.Status) {
          cartItems.SubTotal = data.Data.TotalAmount - data.Data.TotalTaxAmount;
          cartItems.OrderTaxTotal = data.Data.TotalTaxAmount;
          calculatedTotal(cartItems);
        }
      })
      .catch((ex) => {
        console.log(ex);
        getCartItems();
      });
  };

  const removeCartItem = async (id) => {
    await deleteCart("?cartItemId=" + id)
      .then(({ data }) => {
        if (data.Status) {
          cartItems.CartItemCount = data.Data.CartItemCount;
          cartItems.CartItems = cartItems.CartItems.filter((i) => i.Id !== id);
          cartItems.SubTotal = (data.Data.TotalAmount - data.Data.TotalTaxAmount).toFixed(2);
          cartItems.OrderTaxTotal = data.Data.TotalTaxAmount;
          calculatedTotal(cartItems);
          setCartItems({ ...cartItems });
          setRelatedProducts(computeRelatedProductsFromCart(cartItems.CartItems));
          if (!loading && cartItems.CartItems.length === 0) {
                setRelatedProducts([]);
                closeCart();
              }
        }
      })
      .catch((ex) => {
        console.log(ex);
      });
  };

  const checkOutItem = () => {
    closeCart();
    history("/checkout");
  };

  const _closeCart = () => {
    closeCart();
    history("/menu");
  };

  const calculatedTotal = (_cartItems) => {
    const calculatedTax = parseFloat(_cartItems.OrderTaxTotal || 0).toFixed(2);
    setTax(calculatedTax);
    const calculatedGrandTotal = (parseFloat(_cartItems.SubTotal || 0) + parseFloat(calculatedTax)).toFixed(2);
    setGrandTotal(calculatedGrandTotal);
    updateCartCount({
      CartItemCount: _cartItems.CartItemCount || 0,
      TotalAmount: calculatedGrandTotal,
    });
  };

  useEffect(() => {
    setCartItems({ CartItems: [] });
    getCartItems();
  }, [cartDrawer]);

  // Initialize swiper after component mounts
  useEffect(() => {
    if (isCartOpen && !swiperInitialized) {
      setSwiperInitialized(true);
    }
    const accessToken = localStorage.getItem("authToken");
    setIsAuthenticated(accessToken && accessToken.length ? true : false);
  }, [isCartOpen, swiperInitialized]);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 6,
      partialVisibilityGutter: 0,
    },
    tablet: {
      breakpoint: { max: 1024, min: 480 },
      items: 4,
      partialVisibilityGutter: 0,
    },
    mobile: {
      breakpoint: { max: 480, min: 0 },
      items: 3,
      partialVisibilityGutter: 0,
    },
  };

  // useEffect(() => {
  //   if (!loading && cartItems.CartItems.length === 0) {
  //     setRelatedProducts([]);
  //     closeCart();
  //   }
  // }, [cartItems, loading]);

  const PopularButtonGroup = ({ next, previous }) => {
    return (
      <div className="slider-controls">
        <button className="custom-prev" onClick={previous}>
          <svg width="10" height="16" viewBox="0 0 10 16" fill="none">
            <path d="M8.5 1L1.5 8L8.5 15" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        <button className="custom-next" onClick={next}>
          <svg width="10" height="16" viewBox="0 0 10 16" fill="none">
            <path d="M1.5 1L8.5 8L1.5 15" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    );
  };

  const handleProductClick = (product) => {
    const hasCustomizations = product.productAttributes && product.productAttributes.length > 0;

    const productWithDefaults = {
      ...product,
      SelectedAddons: [],
      totalPrice: product.Price || 0,
    };

    if (hasCustomizations) {
      setSelectedProduct(productWithDefaults);
      setIsModalOpen(true);
    } else {
      addCart({
        Products: [
          {
            ProductId: product.Id,
            Quantity: 1,
            AttributesXml: null,
          },
        ],
      })
        .then(({ data }) => {
          if (data.Status) {
            customToast.success("Added to Cart", "Your item has been successfully added.");
            updateCartCount({
              CartItemCount: data.Data.CartItemCount,
              TotalAmount: data.Data.TotalAmount,
            });
            updateCartDrawer();
            getCartItems();
          }
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
          customToast.error("Error", "Failed to add item to cart.");
        });
    }
  };

  return (
    <div className={`cart-overlay ${isCartOpen ? "show" : ""}`} onClick={closeCart}>
      <div className={`cart-drawer ${isCartOpen ? "open" : ""}`} onClick={(e) => e.stopPropagation()}>
        {/* HEADER */}
        <div className="cart-header">
          <h3>My Cart</h3>
          <span className="close" onClick={closeCart}>
            ✕
          </span>
        </div>

        <div className="cart-list">
          {loading ? (
            <div className="loader-center">
              <AppLoader />
            </div>
          ) : !cartItems || cartItems.CartItems.length === 0 ? (
            <p className="cart-row">Your cart is empty</p>
          ) : (
            cartItems.CartItems?.length > 0 &&
            cartItems.CartItems?.map((item) => (
              <div className="cart-row" key={item.Id}>
                <span className="cart-item-delete" onClick={() => removeCartItem(item.Id)}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" fill="#1a1a1a">
                    <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                  </svg>
                </span>
                <img src={item.Product.PicturURL} alt="" />

                <div className="cart-info">
                  <p className="product-name">{item.Product.Name}</p>
                  <span>${item.Product.Total.toFixed(2) || "0.00"}</span>
                  {item.Product.ProductAttributeDetails.Customizations && item.Product.ProductAttributeDetails.Customizations.length > 0 && (
                    <div className="cart-customization">
                      {item.Product.ProductAttributeDetails.Customizations.map((customization, index) => (
                        <p key={index}>- {customization.AttributeName}</p>
                      ))}
                    </div>
                  )}

                  {item.Product.ProductAttributeDetails.Addons && item.Product.ProductAttributeDetails.Addons.length > 0 && (
                    <>
                      <button className="cart-addon-button" onClick={() => setViewAddons(!viewAddons)}>{viewAddons ? "Hide Add Ons" : "View Add Ons"}</button>
                      <div className="cart-addon">
                        {viewAddons && item.Product.ProductAttributeDetails.Addons.map((addon, index) => (
                          <p key={index}>[+${addon.PriceAdjustment}] {addon.AttributeName}</p>
                        ))}
                      </div>
                    </>
                  )}
                </div>

                <div className="qty-control">
                  <button onClick={() => adjustQty(item.Id, false)}>−</button>
                  <span>{item.Product.Quantity}</span>
                  <button onClick={() => adjustQty(item.Id, true)}>+</button>
                </div>
              </div>
            ))
          )}
        </div>

        {/* ADD MORE */}
        <div className="add-more" onClick={_closeCart}>
          + Add More Items
        </div>

        {/* POPULAR */}
        {relatedProducts.length !== 0 && (
          <div className="popular-section">
            <div className="popular-header">
              <h4 className="heading">Popular with your order</h4>
            </div>

            <div className="popular-slider-container">
              {swiperInitialized && (
                <Carousel
                  responsive={responsive}
                  infinite={true}
                  arrows={false}
                  autoPlay={false}
                  draggable={true}
                  swipeable={true}
                  partialVisible={true}
                  rtl={false}
                  keyBoardControl={true}
                  renderButtonGroupOutside={true}
                  customButtonGroup={<PopularButtonGroup />}
                  containerClass="popular-carousel"
                  itemClass="popular-item"
                >
                  {relatedProducts.map((i) => (
                    <div key={i}>
                      <div className="popular-card">
                        <img src={i.PicturURL || menu} alt="" />
                        <div className="add-btn" onClick={() => handleProductClick(i)}>
                          +
                        </div>
                      </div>
                      <p className="popular-name">{i.Name.length > 7 ? i.Name.slice(0, 7) + "... " : i.Name}</p>
                      <span className="popular-price">${i.Price}</span>
                    </div>
                  ))}
                </Carousel>
              )}
            </div>
          </div>
        )}

        {/* FOOTER */}
        <div className="cart-footer">
          <div className="total-row">
            <span>Subtotal</span>
            <strong>${subtotal}</strong>
          </div>
          <div className="total-row">
            <span>Tax 15%</span>
            <strong>${tax}</strong>
          </div>

          <div className="total-row">
            <span>Total</span>
            <strong>${grandTotal}</strong>
          </div>
          {isAuthenticated ? (
            <button
              disabled={loading || cartItems?.CartItems?.length === 0}
              className={`checkout-btn ${!loading && cartItems?.CartItems?.length !== 0 ? "place-order-btn" : "btn-disabled"}`}
              onClick={() => checkOutItem()}
            >
              CHECKOUT – ${grandTotal}
            </button>
          ) : (
            <button
              disabled={loading}
              className={`checkout-btn ${!loading ? "place-order-btn" : "btn-disabled"}`}
              onClick={() => history("/login?redirect=/checkout")}
            >
              Sign-in to Continue
            </button>
          )}
        </div>
      </div>
      <ProductCustomizationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} product={selectedProduct} toastLink={null} />
    </div>
  );
}

export default CartDrawer;
